import { datadogLogs } from '@datadog/browser-logs';

import { config } from '../config';

export async function initializeDatadog() {
  // disable this condition to test datadog functionality locally
  if (config.datadog.env === 'local') {
    return;
  }

  const site = 'datadoghq.com';

  const commonOptions = {
    silentMultipleInit: true,

    site,

    trackSessionAcrossSubdomains: true,
    useCrossSiteSessionCookie: true,
    useSecureSessionCookie: config.datadog.env !== 'local',
  };

  datadogLogs.init({
    ...config.datadog,
    ...commonOptions,

    sessionSampleRate: 0,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error', 'warn'],
    forwardReports: ['csp_violation', 'deprecation', 'intervention'],
  });
}
